module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "dropzone",
    staticClass: "dropzone",
    on: {
      "click": _vm.clearDropzone
    }
  }), _vm._v(" "), _c('script', {
    ref: "template",
    attrs: {
      "type": "text/x-template",
      "id": "dropzone-preview-template"
    }
  }, [_vm._v("\n    <div class=\"dz-preview dz-file-preview\">\n      <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n    </div>\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f4d41e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/dropzone.vue
// module id = 516
// module chunks = 0